<template>
  <v-expand-transition>
    <v-card
      :id="sectionElId(section)"
      style="margin-bottom:20px;border:1px rgba(0,0,0,0.1) solid;"
      v-if="showSection"
    >
      <v-toolbar
        dense
        flat
        color="rgba(0,0,0,0.09)"
        height="auto"
        style="padding-top:10px;padding-bottom:10px;"
      >
        <strong
          v-if="section.number"
          v-html="section.number + '.'"
        ></strong>
        &nbsp;
        <span
          class="inlineLimiter"
          v-html="section.text"
        ></span>
        <v-spacer />
        <v-icon
          v-if="section.tip_text"
          class="help_button"
          style="float: right;cursor: hand;"
          @click="tip_dialog=true"
        >
          mdi-help-circle
        </v-icon>
      </v-toolbar>
      <v-card-text>
        <v-alert
          :value="section.read_only"
          type="warning"
          outline
        >
          This section is read only. You are unable to modify any of the questions in this section.
        </v-alert>
        <UserFormPartList
          :parts="section.parts"
          :user-form-id="userFormId"
          :read-only="section.read_only"
        />
      </v-card-text>
      <v-dialog
        v-model="tip_dialog"
        width="650"
      >
        <v-card>
          <v-toolbar
            flat
            dark
            dense
          >
            Section Details Tip
          </v-toolbar>
          <v-card-text>
            <div v-html="section.tip_text" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="tip_dialog=false"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-expand-transition>
</template>

<script>
import answermixin from '@/components/global/atomic/answermixin'
import { mapGetters } from 'vuex'
import UserFormPartList from './UserFormPartList'
import GlobalConstants from '@/globals'

export default {
  name: 'UserFormSection',
  mixins: [answermixin], 
  props: ['userFormId', 'section'],
  data () {
    return {
      tip_dialog: false,
    }
  },
  beforeCreate () {
    this.$options.components.UserFormPartList = UserFormPartList
  },
  methods: {
    sectionElId (section) {
      return `section-${section.id}`
    }
  },
  computed: {
    ...mapGetters('userform', [
      'answer',
      'parts'
    ]),
    showSection(){
      return GlobalConstants.MeetsCondition(this.section, this.answer, this.parts)
    }
  },
  mounted () {
    if (window.location.hash === '#' + this.sectionElId(this.section)) {
      this.$vuetify.goTo(window.location.hash, { duration: 300, offset: 0, easing: 'easeInOutCubic' })
    }
  }
}
</script>

<style scoped>
.inlineLimiter >>> :first-child {
  display:inline;
}
</style>
